import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-helpbutton-new-staff-dashboard',
  templateUrl: './helpbutton-new-staff-dashboard.component.html',
  styleUrls: ['./helpbutton-new-staff-dashboard.component.scss']
})
export class HelpbuttonNewStaffDashboardComponent implements OnInit {

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-user-cog', 'helpbutton-page.new staff', '/helpbutton/staffs', [new BRoute('helpbutton-page.helpbutton', '/helpbutton'), new BRoute('helpbutton-page.staffs', '/helpbutton/staffs'), new BRoute('helpbutton-page.new staff')]));
  }
}
